const breakpoints = {
  mobile: 375,
  table: 768,
  laptop: 1280,
  desktop: 1920,
};

export default breakpoints;
